/**
 * PARA ONDE A NOTIFICAÇÃO LEVA — uma régua só para o sino e para a página de Notificações (2026-10-29).
 *
 * A de tarefa ("Nova tarefa", "Tarefa reaberta", "Comentário na tarefa…") não levava a lugar nenhum: o clique só
 * marcava como lida, e a pessoa ia procurar a tarefa à mão. `Minhas Tarefas` abre o detalhe por `?tarefa=` — para
 * o responsável e também para quem a pediu (o servidor libera o detalhe para os dois).
 */
export function rotaDaNotificacao(n) {
  if (!n || !n.referencia_id) return null;
  if (n.tipo === 'esteira_mencao') return `/esteira?card=${n.referencia_id}`;
  if (n.tipo === 'tarefa') return `/minhas-tarefas?tarefa=${n.referencia_id}`;
  return null;
}
